import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { BrowserModule } from '@angular/platform-browser';

import { CategoryTreeRoot } from './category.tree.root';
import { CategoryTreeItem } from './tree.item';
import { MatCategoryTreeRoot } from './mat.category.tree.root';
import { MatCategoryTreeItem } from './mat.tree.item';
import { B2BAngularMaterialModule } from '../angular.material/b2b.angular.material.module';
import { AuthModule } from '../../../auth/auth.module';

@NgModule({
    declarations: [CategoryTreeRoot, CategoryTreeItem, MatCategoryTreeRoot, MatCategoryTreeItem],
    imports: [BrowserModule, FormsModule, B2BAngularMaterialModule, AuthModule],
    exports: [CategoryTreeRoot, MatCategoryTreeRoot]
})

export class CategoryTreeViewModule { }


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/common/category.tree.view/category.tree.view.module.ts